var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { PowerIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { changeUserSessionStatusRequest, deleteUserSessionRequest, } from "../../../api/api";
import { CHANGE_USER_SESSION_STATUS, DELETE_USER_SESSION, } from "../../../constants";
import { useTimezone } from "../../../hooks/useTimezone";
import { AppContext } from "../../../providers/AppContextProvider";
import { UserSessionsContext } from "../../../providers/UserSessionsContextProvider";
function UserSession({ session }) {
    const { usersSessionDispatch } = useContext(UserSessionsContext);
    const { state: { isUserAllowedToDelete }, } = useContext(AppContext);
    const { convertToWPTimezone } = useTimezone();
    const isActive = session.is_active;
    const changeSessionStatus = (status) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield changeUserSessionStatusRequest(session.id, status);
            usersSessionDispatch({
                type: CHANGE_USER_SESSION_STATUS,
                payload: { sessionId: session.id, status },
            });
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to change session status", "quicktasker"));
        }
    });
    const deleteSession = () => __awaiter(this, void 0, void 0, function* () {
        try {
            yield deleteUserSessionRequest(session.id);
            usersSessionDispatch({
                type: DELETE_USER_SESSION,
                payload: session.id,
            });
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to delete session", "quicktasker"));
        }
    });
    return (_jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsx("div", { children: session.user_name }), _jsx("div", { className: "wpqt-italic", children: session.user_description })] }), _jsx("div", { children: convertToWPTimezone(session.created_at_utc) }), _jsx("div", { children: convertToWPTimezone(session.expires_at_utc) }), _jsx("div", { className: isActive ? "wpqt-text-qtTextGreen" : "wpqt-text-qtTextRed", children: isActive ? __("On", "quicktasker") : __("Off", "quicktasker") }), _jsxs("div", { className: "wpqt-flex wpqt-items-center wpqt-gap-4", children: [isActive ? (_jsx(PowerIcon, { className: "wpqt-icon-red wpqt-size-5 wpqt-cursor-pointer", onClick: () => changeSessionStatus(false), title: __("Turn session off", "quicktasker") })) : (_jsx(PowerIcon, { className: "wpqt-icon-green wpqt-size-5 wpqt-cursor-pointer", onClick: () => changeSessionStatus(true), title: __("Turn session on", "quicktasker") })), isUserAllowedToDelete && (_jsx(TrashIcon, { className: "wpqt-icon-red wpqt-size-5 wpqt-cursor-pointer", title: __("Delete session", "quicktasker"), onClick: deleteSession }))] })] }));
}
export { UserSession };
